import {
  OR_CHOOSE_ADDRESS,
  OR_CHOOSE_FREQUENCY,
  OR_CLOSE_CONFLICTING_ORDERS_MODAL,
  OR_RECEIVE_SLOTS,
  OR_RECEIVE_SLOTS_ERROR,
  OR_REGISTRATION_RESET_DATA,
  OR_REQUEST_SLOTS,
} from '../../actions/registration/ordersReservedRegistration';

export const initialState = {
  slots: [],
  isFetchingSlots: false,
  isSlotsError: false,
  conflictingOrders: [],
  conflictingOrdersModalVisible: false,
};

const ACTIONS = {
  [OR_REQUEST_SLOTS]: ({ state }) => ({ ...state, isFetchingSlots: true, conflictingOrders: [] }),
  [OR_RECEIVE_SLOTS]: ({ state, action }) => ({
    ...state,
    slots: action.data.slots || [],
    isFetchingSlots: false,
    isSlotsError: false,
    conflictingOrders: action.data.conflictingOrders || [],
    conflictingOrdersModalVisible: !!(action.data.conflictingOrders && action.data.conflictingOrders.length),
  }),
  [OR_RECEIVE_SLOTS_ERROR]: ({ state }) => ({ ...state, slots: [], isFetchingSlots: false, isSlotsError: true }),
  [OR_CLOSE_CONFLICTING_ORDERS_MODAL]: ({ state }) => ({ ...state, conflictingOrdersModalVisible: false }),
  [OR_CHOOSE_ADDRESS]: ({ state, action }) => {
    if (action.hasChanged === false) {
      return state;
    }
    return initialState;
  },
  [OR_CHOOSE_FREQUENCY]: ({ state, action }) => {
    if (action.hasChanged === false) {
      return state;
    }
    return initialState;
  },
  [OR_REGISTRATION_RESET_DATA]: () => initialState,
};

export default function slotsReducer(state = initialState, action) {
  return ACTIONS[action.type] ? ACTIONS[action.type]({ state, action }) : state;
}
